import { useMemo, useCallback, useContext, useState } from 'react';
import _ from 'underscore';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { PaymentContext } from '@bingads-webui-cc-react/payment-context';

export const useSignupAddFundsResult = ({
  success = _.noop,
  fail = _.noop,
  cancel = _.noop,
}) => {
  const [submitting, setSubmitting] = useState(false);
  const [CtpPiId, setCtpPiId] = useState(null);
  const [MtPiId, setMtPiId] = useState(null);

  const successCallback = useCallback(
    (...params) => {
      setSubmitting(false);
      success(...params);
    },
    [success]
  );
  const failCallback = useCallback(
    (...params) => {
      setSubmitting(false);
      fail(...params);
    },
    [fail]
  );
  const cancelCallback = useCallback(
    (...params) => {
      setSubmitting(false);
      cancel(...params);
    },
    [cancel]
  );
  const startSubmit = useCallback(({
    ctpPiId = null,
    mtPiId = null,
  }) => {
    setCtpPiId(ctpPiId);
    setMtPiId(mtPiId);
    setSubmitting(true);
  }, []);

  return useMemo(
    () => ({
      submitting,
      success: successCallback,
      fail: failCallback,
      cancel: cancelCallback,
      startSubmit,
      CtpPiId,
      MtPiId,
    }),
    [CtpPiId, MtPiId, cancelCallback, failCallback, startSubmit, submitting, successCallback]
  );
};

export const useShouldShowAddFundsForm = (
  paymentType,
  piType,
  paymentCountry,
  isSmartAddFundsEnabled
) => {
  const {
    paymentContext: {
      SmartCountriesDisabledForCreditCardAddFunds,
    },
  } = useContext(PaymentContext);


  return isSmartAddFundsEnabled
    && paymentType === Constants.PaymentTypeId.Prepay
    && piType !== Constants.PaymentInstrumentType.Unset
    && (
      piType !== Constants.PaymentInstrumentType.CreditCard
      || !_.contains(SmartCountriesDisabledForCreditCardAddFunds, paymentCountry)
    );
};

export const getToggleStyles = () => ({
  toggleWrapper: {
    '& .switch': {
      position: 'relative',
      display: 'inline-block',
      width: '40px',
      height: '20px',
    },
    '& .switch input': {
      display: 'none',
    },
    '& .slider': {
      position: 'absolute',
      cursor: 'pointer',
      top: '0',
      left: '0',
      right: '0',
      bottom: '0',
      'background-color': '#fff',
      border: '1px solid #333',
      transition: '.4s',
      '&.round': {
        'border-radius': '30px',
        '&:before': {
          'border-radius': '50%',
        },
      },
    },
    '& .slider:before': {
      position: 'absolute',
      content: '""',
      height: '10px',
      width: '10px',
      left: '4px',
      bottom: '4px',
      'background-color': '#333',
      transition: '.4s',
    },
    '& input:checked + .slider': {
      'background-color': '#008272',
      'border-color': '#008272',
    },
    '& input:focus + .slider': {
      'box-shadow': '0 0 1px #008272',
    },
    '& input:checked + .slider:before': {
      transform: 'translateX(20px)',
      'background-color': '#fff',
    },
    '& input:disabled + .slider': {
      'background-color': '#f4f4f4',
      border: '1px solid #ddd',
    },
    '& input:disabled + .slider:before': {
      'background-color': '#767676',
    },
  },
  toggleStatus: {
    position: 'absolute',
    'line-height': '20px',
    'margin-left': '5px',
  },
});
